<template>
  <div className="animated">
    <b-card>
      <b-card-header>
        <i class="icon-menu mr-1"></i>Devices
      </b-card-header>
      <b-card-body>
        <div class="search-box">
          <b-form-group class="search-condition">
            <b-form-select v-model="searchOption.stolen"
              :plain="true"
              :options="stolenOptions">
            </b-form-select>
          </b-form-group>
          <b-form-group class="search-condition">
            <b-form-select v-model="searchOption.registered"
              :plain="true"
              :options="registeredOptions">
            </b-form-select>
          </b-form-group>
          <b-form-group class="search-condition">
            <range-date-picker :initRange="initRange" @selected="onDateSelected" class="date-picker" />
          </b-form-group>
          <b-button type="submit" variant="primary" class="btn-pill" @click.stop="search">
            <i class="fa fa-search"></i>&nbsp;Search
          </b-button>
        </div>        
        <Devices :key="componentKey" :searchOption="searchOption"/>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import RangeDatePicker from '../../components/RangeDatePicker'
  import { utils } from '../../mixins/utils'  
  import Devices from '../devices/Devices'

  export default {
    name: 'DeviceList',
    mixins: [utils],
    components: {
      RangeDatePicker,
      Devices
    },
    data: function() {
      return {
        componentKey: 0,
        searchOption: {
          stolen: false,
          registered: null,
          createdFrom: null,
          createdTo: null
        },
        stolenOptions: [
          { value: null, text: 'All'},
          { value: false, text: 'Normal'},          
          { value: true, text: 'Stolen'},
        ],
        registeredOptions: [
          { value: null, text: 'All'},
          { value: false, text: 'Unregistered'},
        ],
      }
    },
    computed: {
      initRange() {
        return {
          start: this.$moment(this.searchOption.createdFrom, 'YYYY-MM-DD').startOf('day').toDate(),
          end: this.$moment(this.searchOption.createdTo, 'YYYY-MM-DD').endOf('day').toDate(),
        }
      }
    },
    created() {
      this.initSearchOptionFromQuery()
      this.updateUrl()
    },
    methods: {
      onDateSelected(selected) {
        console.info('from:' + selected.start + ' to:' + selected.end)
        this.searchOption.createdFrom = selected.start
        this.searchOption.createdTo = selected.end
      },
      initSearchOptionFromQuery() {
        if (this.$route.query.hasOwnProperty('stolen')) this.searchOption.stolen = this.toBoolOrNull(this.$route.query.stolen)
        if (this.$route.query.hasOwnProperty('registered')) this.searchOption.registered = this.toBoolOrNull(this.$route.query.registered)
        Object.assign(this.searchOption, this.$route.query)
        if (this.isValidQueryCreatedDate(this.searchOption)) return
        this.searchOption.createdFrom = this.$moment(this.$store.getters.lastDateRange.start).format('YYYY-MM-DD')
        this.searchOption.createdTo = this.$moment(this.$store.getters.lastDateRange.end).format('YYYY-MM-DD')
      },
      updateUrl() {
        const query = JSON.parse(JSON.stringify(this.$route.query))
        if (this._.isEqual(query, this.searchOption)) return

        console.log('replace query', query, this.searchOption)
        this.$router.replace({ path: this.$route.path, query: this.searchOption })
        console.log('replace route query', this.$route.query)
      },
      search() {
        console.info('search() ', this.searchOption)
        this.updateUrl()
        this.componentKey += 1
      }
    }
  };
</script>
